// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2702af22","453":"d456ce70","730":"ec8233f3"}[chunkId] + ".chunk.js";
};